import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';

import { Internship } from './internship';

@Component({
  selector: 'app-internship',
  templateUrl: './internships.component.html',
  styleUrls: ['./internships.component.scss']
})
export class InternshipsComponent implements OnInit {

  internshipNames = ['uiuxdesigner', 'uiengineer', 'datalakeengineer', 'dbengineer', 'marketingintern',
  'middlewareengineer', 'soaengineer', 'salesintern', 'aimlengineer'];
  internships: Internship[];
  currInternship: number;

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: any
  ) {
    this.currInternship = -1;
    this.internships = [];
  }

  chooseStyle(isActive: boolean, isFirst: boolean): any {
    const object = isActive ? { 'max-height': '3000px' } : {};
    if (!isFirst) {
      object['border-top'] = '3px solid grey';
    }
    return object;
  }

  async ngOnInit() {
    // Read in members arr
    for (let internshipName of this.internshipNames) {
      try {
        let internship = await this.http.get(`assets/json/internships/${internshipName}.json`)
          .toPromise() as Internship;
        internship.isActive = false;
        this.internships.push(internship);
      } catch (err) {
        console.log(err);
      }
    }
  }

  scroll(anchor: string) {
    document.getElementById(anchor).scrollIntoView();
  }

}
